export const POPULAR_WIDGET_ERROR = 'POPULAR_WIDGET_ERROR';
export const POPULAR_WIDGET_LOADING_SUCCESS = 'POPULAR_WIDGET_LOADING_SUCCESS';
export const POPULAR_WIDGET_START_LISTENING_FOR_WS_UPDATES = 'POPULAR_WIDGET_START_LISTENING_FOR_WS_UPDATES';
export const POPULAR_WIDGET_STOP_LISTENING_FOR_WS_UPDATES = 'POPULAR_WIDGET_STOP_LISTENING_FOR_WS_UPDATES';
